export const PAY_TYPE = [{
    label: '微信支付',
    value: 1
},
{
    label: '余额支付',
    value: 6
},
{
    label: '线下支付',
    value: 7
},
{
    label: '扫码支付',
    value: 8
},
{
    label: '卡券支付',
    value: 9
}
]